import { render, staticRenderFns } from "./IconSvgBookClosed.vue?vue&type=template&id=600c0adf&scoped=true&"
import script from "./IconSvgBookClosed.vue?vue&type=script&lang=js&"
export * from "./IconSvgBookClosed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600c0adf",
  null
  
)

export default component.exports